import { Component, Vue } from 'vue-property-decorator'

@Component({
  template: require('template/contacts.html'),
  components: {}
})
export default class Contacts extends Vue {
  pageTitle: string = 'Контактная информация'
}
